<ng-container *ngIf="data">
    <div class="mb-4">
        <button class="btn btn-primary btn-round btn-slim" [routerLink]="['/product-ranges']">Back</button>
    </div>
    <h1 class="border-gray border-bottom text-center pb-4 mb-5">
        <ng-container *ngIf="!newItem">
            <small>{{data.productCode}}</small>
            {{data.name}}
        </ng-container>
        <ng-container *ngIf="newItem">
            New Product Range
        </ng-container>
    </h1>
    <div class="row">
        <div class="col-12">
            <form [formGroup]="form" autocomplete="off" novalidate [autocomplete]="'off'" (ngSubmit)="onSubmit()">
                <div class="card border-0 bg-white shadow-sm mb-4">
                    <div class="card-body p-xl-5">
                        <h3>Hero Banner</h3>
                        <p class="mb-4">Upload a banner image to show at the top of the page</p>
                        <div class="vendor-logo text-center mb-4">
                            <div style="position: relative">
                                <div *ngIf="!form.value.bannerUrl">
                                    <img src="/assets/images/no-image.png" class="img-fluid"
                                        style="max-height: 150px" />
                                </div>
                                <div *ngIf="form.value.bannerUrl">
                                    <div [ngStyle]="{'background-image': 'url(' + form.value.bannerUrl + ')'}"
                                        class="blog-banner d-flex flex-column justify-content-center align-items-center">

                                        <h1 style="color: white!important">{{form.value.name}}</h1>
                                        <p class="mb-0" style="width: 70%; margin: 0 auto">{{form.value.bannerText}}</p>
                                    </div>
                                </div>
                                <button *ngIf="form.value.bannerUrl" class="btn btn-danger btn-sm"
                                    style="position: absolute; bottom: 10px; right: 10px"
                                    (click)="deleteIntroBackground()">
                                    <img src="assets/images/icon-trash.svg" class="product-range-trash">
                                </button>
                            </div>
                        </div>
                        <div class="text-center">
                            <button type="button" *ngIf="form.value.bannerUrl" class="btn btn-primary btn-round"
                                (click)="viewImageLibrary('banner', 'introBackground')">Update banner image
                            </button>
                            <button type="button" *ngIf="!form.value.bannerUrl" class="btn btn-primary btn-round"
                                (click)="viewImageLibrary('banner', 'introBackground')">Add banner image
                            </button>
                        </div>
                    </div>
                </div>

                <div class="card border-0 bg-white shadow-sm mb-4">
                    <div class="card-body p-xl-5">
                        <h3 class="mb-4">Range Meta</h3>
                        <div class="row g-3">
                            <div class="col-12 col-lg-6">
                                <div class="row mb-3">
                                    <div class="col-12">
                                        <label class="fw-bold text-primary mb-1">
                                            Name <span [ngClass]="{'asteriks-invalid' : form.controls.name.invalid
                                            && form.controls.name.touched}">*</span>
                                        </label>
                                    </div>
                                    <div class="col-12">
                                        <input type="text" autocomplete="new-password" class="form-control"
                                            [ngClass]="{'is-invalid' : form.controls.name.invalid && form.controls.name.touched}"
                                            formControlName="name" placeholder="Range name">
                                        <div class="invalid-feedback">Name is required</div>
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-12">
                                        <label class="fw-bold text-primary mb-1">
                                            URL <span
                                                [ngClass]="{'asteriks-invalid' : form.controls.slug.invalid && form.controls.slug.touched}">*</span>
                                        </label>
                                    </div>
                                    <div class="col-12">
                                        <input type="text" autocomplete="new-password" class="form-control"
                                            [ngClass]="{'is-invalid' : form.controls.slug.invalid && form.controls.slug.touched}"
                                            formControlName="slug" placeholder="Group URL">
                                        <div class="invalid-feedback">
                                            URL is required
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-12">
                                        <label class="fw-bold text-primary mb-1">
                                            Tile text <small
                                                [ngClass]="{'text-danger' : form.value.tileText.length >= maxTileText}">({{form.value.tileText.length}}
                                                of {{maxTileText}} characters entered)
                                                <span [ngClass]="{'asteriks-invalid' : form.controls.tileText.invalid
                                                && form.controls.tileText.touched}">*</span>
                                            </small>
                                        </label>
                                        <div class="text-muted mb-1">
                                            Enter a short descriptive paragraph to be shown on preview tiles.
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <textarea
                                            [ngClass]="{'is-invalid' : form.controls.tileText.invalid && form.controls.tileText.touched}"
                                            class="form-control" rows="3" formControlName="tileText"
                                            placeholder="Enter tile text"></textarea>
                                        <div class="invalid-feedback"> {{form.controls.tileText.hasError('required') ?
                                            'Tile text is required' :
                                            'Must be less than ' + maxTileText + ' characters'}}</div>
                                    </div>

                                </div>

                                <div class="row mb-3">
                                    <div class="col-12">
                                        <label class="fw-bold text-primary mb-1">
                                            Banner text <small
                                                [ngClass]="{'text-danger' : form.value.bannerText.length >= maxBannerText}">({{form.value.bannerText.length}}
                                                of {{maxBannerText}} characters entered)
                                                <span [ngClass]="{'asteriks-invalid' : form.controls.bannerText.invalid
                                            && form.controls.bannerText.touched}">*</span>
                                            </small>
                                        </label>
                                        <div class="text-muted mb-1">
                                            Enter a short descriptive paragraph to be shown as part main page banner.
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <textarea
                                            [ngClass]="{'is-invalid' : form.controls.bannerText.invalid && form.controls.bannerText.touched}"
                                            class="form-control" rows="3" formControlName="bannerText"
                                            placeholder="Enter banner text"></textarea>
                                        <div class="invalid-feedback"> {{form.controls.bannerText.hasError('required') ?
                                            'Banner text is required' :
                                            'Must be less than ' + maxBannerText + ' characters'}}</div>

                                    </div>
                                </div>

                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="vendor-logo text-center mb-4">
                                    <div>
                                        <img *ngIf="!form.value.imageUrl" src="/assets/images/no-image.png"
                                            class="img-fluid" style="max-height: 250px" />
                                        <img *ngIf="form.value.imageUrl" [src]="form.value.imageUrl" class="img-fluid"
                                            style="max-height: 250px" />
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center align-items-center">
                                    <button type="button" class="btn btn-primary btn-sm btn-slim"
                                        [ngClass]="{'me-4': form.value.imageUrl}"
                                        (click)="viewImageLibrary('cms', 'tile')">
                                        <ng-container *ngIf="form.value.imageUrl">Update Preview Tile</ng-container>
                                        <ng-container *ngIf="!form.value.imageUrl">Add Preview Tile</ng-container>
                                    </button>
                                    <button *ngIf="form.value.imageUrl" type="button"
                                        class="btn btn-danger btn-sm btn-slim" (click)="deleteTile()">
                                        Delete image
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card border-0 bg-white shadow-sm mb-4">
                    <div class="card-body p-xl-5">

                        <div class="row mb-3">
                            <div class="col-12">
                                <label class="fw-bold text-primary mb-1">
                                    Supplier <span [ngClass]="{'asteriks-invalid' : form.controls.supplier.invalid
                                    && form.controls.supplier.touched}">*</span>
                                </label>
                            </div>
                            <div class="col-12">

                                <ng-select class="dark" (ngModelChange)="supplierChange($event)" formControlName="supplier" [clearable]="false"
                                    [searchable]="true" [closeOnSelect]="true" [placeholder]="'Select supplier'"
                                    [multiple]="false">
                                    <ng-option *ngFor="let supplier of suppliers" [value]="supplier.id">
                                        {{supplier.name}}
                                    </ng-option>
                                </ng-select>

                                <div class="invalid-feedback">Select a supplier</div>
                            </div>

                        </div>
                        <div class="row mb-3" *ngIf="showCollectionAddress">
                            <div class="col-12">
                                <label class="fw-bold text-primary mb-1">
                                    Collection Address
                                </label>
                            </div>
                            <div class="col-12">
                                <ng-select class="dark" formControlName="collectionAddress" [clearable]="false"
                                    [searchable]="true" [closeOnSelect]="true" placeholder="Select collection address"
                                    [multiple]="false">
                                    <ng-option *ngFor="let collection of this.collectionAddresses"
                                        [value]="collection.id">
                                        {{collection.add1}}, {{collection.town}}, {{collection.postcode}}
                                    </ng-option>
                                </ng-select>
                                <div class="invalid-feedback">Select Collection Address</div>
                            </div>

                        </div>

                        <div class="mb-3" *ngIf="(user$ |async)?.permissions?.productModule?.productDomains">
                            <label>Valid domains</label>
                            <ng-select formControlName="domains" [clearable]="false" [searchable]="false"
                                [closeOnSelect]="false" [placeholder]="'Select domains'" [multiple]="true" class="dark">
                                <ng-option [value]="domain.id" *ngFor="let domain of domains">
                                    {{domain.name}}
                                </ng-option>
                            </ng-select>
                            <div class="invalid-feedback">Select product range domains</div>
                        </div>


                        <div class="row mb-3">
                            <div class="col-12">
                                <a (click)="togglePreviewSlider()">
                                    <i class="toggle fa" [ngClass]="{
                            'fa-toggle-on text-success': form.value.showInPreviewSlider,
                            'fa-toggle-off' : !form.value.showInPreviewSlider}"></i>
                                    Show in preview slider?
                                </a>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-12">
                                <a (click)="toggleMainMenu()">
                                    <i class="toggle fa" [ngClass]="{
                            'fa-toggle-on text-success': form.value.showInMainMenu,
                            'fa-toggle-off' : !form.value.showInMainMenu}"></i>
                                    Show in main menu?
                                </a>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <a (click)="toggleAvailable()">
                                    <i class="toggle fa" [ngClass]="{
                            'fa-toggle-on text-success': form.value.available,
                            'fa-toggle-off' : !form.value.available}"></i>
                                    Make live?
                                </a>

                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="!newItem" class="card border-0 bg-white shadow-sm mb-4">
                    <div class="card-body p-xl-5">
                        <h3 class="mb-3">Product Types Supplied</h3>
                        <div class="table-responsive">
                            <table class="table table-borderless align-middle w-100">
                                <thead>
                                    <tr>
                                        <th>Product type</th>
                                        <th class="text-center">Supplied?</th>
                                        <th class="text-center">Configuration</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let pt of productTypes">
                                        <td class="col-5">{{pt.name}}</td>
                                        <td class="text-center">
                                            <a (click)="toggleProductTypes(pt)">
                                                <i class="toggle fa"
                                                    [ngClass]="{'fa-toggle-on text-success': productTypeSelected(pt.id) >= 0, 'fa-toggle-off' : productTypeSelected(pt.id) < 0}"></i>
                                            </a>
                                        </td>
                                        <td class="text-center">
                                            <a *ngIf="productTypeSelected(pt.id) >= 0" (click)="editProductType(pt)">
                                                <i class="fa fa-cog"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="card border-0 bg-white shadow-sm mb-4">
                    <div class="card-body p-xl-5">
                        <h3 class="mb-3">Search Engine Optimisation</h3>
                        <div class="mb-3 row">
                            <div class="col-12">
                                <label class="fw-bold text-primary mb-1">
                                    Page meta title <span [ngClass]="{'asteriks-invalid' : form.controls.seoTitle.invalid
                                    && form.controls.seoTitle.touched}">*</span>
                                </label>
                            </div>
                            <div class="col-12">
                                <input type="text"
                                    [ngClass]="{'is-invalid' : form.controls.seoTitle.invalid && form.controls.seoTitle.touched}"
                                    class="form-control" formControlName="seoTitle" />
                                <div class="invalid-feedback">Page meta title is required</div>
                            </div>
                        </div>
                        <div class="mb-3 row">
                            <div class="col-12">
                                <label class="fw-bold text-primary mb-1">
                                    Meta description <span [ngClass]="{'asteriks-invalid' : form.controls.seoDescription.invalid
                                    && form.controls.seoDescription.touched}">*</span>
                                </label>
                            </div>
                            <div class="col-12">
                                <textarea
                                    [ngClass]="{'is-invalid' : form.controls.seoDescription.invalid && form.controls.seoDescription.touched}"
                                    class="form-control" rows="4" formControlName="seoDescription"></textarea>
                                <div class="invalid-feedback">Page meta description is required</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center align-items-center">
                    <button [disabled]="form.invalid" class="btn btn-lg btn-primary fw-bold mt-4" type="submit"
                        tabindex="3">
                        Submit
                    </button>
                </div>
            </form>
        </div>
    </div>
</ng-container>

<!-- <pre>{{findInvalidControls() | json}}</pre> -->
<app-product-range-configure *ngIf="(overlays$ | async).productTypeConfigure" [overlayData]="overlayData">
</app-product-range-configure>

<app-images *ngIf="showImageLibrary" [ownerId]="'cms'" [type]="imageLibraryType" [allowSelection]="false"
    (modalAction)="libraryModalAction($event)" (imageSelected)="imageSelected($event)"></app-images>